import React from 'react';
import { useQuery } from '@apollo/client';
import IFieldsetProps from '../../../utils/types/IFieldsetProps';
import { GET_LIFECYCLE_STATUSES_QUERY } from '../../../utils/statApi/EntityStatusApi';
import QueryBasedDropdown from './queryBasedDropdown/QueryBasedDropdown';
import IDropdownReference from '../../../utils/types/IDropdownReference';

interface LifecycleStatusDropdownProps extends IFieldsetProps {
  selectableFieldNames?: string[];
  dropdownOptionsData?: IDropdownReference[];
}

const LifecycleStatusDropdown = (props: LifecycleStatusDropdownProps): JSX.Element => {
  const {
    value,
    label,
    required,
    errors,
    handleChange,
    valueKey,
    outputKey,
    dropdownOptionsData,
    selectableFieldNames = [],
  } = props;
  const { loading, data: lifecycleData } = useQuery(GET_LIFECYCLE_STATUSES_QUERY);
  const { lifecycleStatuses } = !loading && lifecycleData ? lifecycleData : [];
  // default to all selectable if none provided
  const internalDropdownOptionsData = lifecycleStatuses?.map(
    (lifecycleStatus: IDropdownReference & { fieldName?: string }) => ({
      ...lifecycleStatus,
      isSelectable:
        selectableFieldNames.length === 0
          ? true
          : selectableFieldNames.some((item) => item === lifecycleStatus.fieldName),
    }),
  );

  const dropdownOptions = dropdownOptionsData ?? internalDropdownOptionsData;

  return (
    <QueryBasedDropdown
      value={value as IDropdownReference}
      label={label}
      required={required}
      outputKey={outputKey}
      dropdownOptionsData={dropdownOptions}
      errors={errors}
      handleChange={handleChange}
      valueKey={valueKey}
    />
  );
};

export default LifecycleStatusDropdown;
